module.exports = __webpack_public_path__ + "static/img/5g3.1929436.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5g3.png
// module id = DjDU
// module chunks = 21